import React, { useState } from "react"
import styled from "styled-components"
import _uniqueId from "lodash/uniqueId"

import { format } from "date-fns"
import { ko } from "date-fns/locale"
export default function TaskResultTimeStamp() {
  const [timestampId] = useState(_uniqueId("task-result-timestamp-"))
  return (
    <TimeWrapper key={`${timestampId}`}>
      <TimeContentWrapper>
        <TimeTop>{`${format(new Date(), "yyyy. MM. dd (ccc)", {
          locale: ko,
        })}`}</TimeTop>
        <TimeBottom>
          {`${format(new Date(), "hh")}`}
          <FontSpacer style={{ width: `calc(100vw*(8/375) * 3.84)` }}></FontSpacer>
          {`:`}
          <FontSpacer style={{ width: `calc(100vw*(7/375) * 3.84)` }}></FontSpacer>
          {`${format(new Date(), "mm")}`}
          <FontSpacer style={{ width: `calc(100vw*(10/375) * 3.84)` }}></FontSpacer>
          {`${format(new Date(), "aa")}`}
        </TimeBottom>
      </TimeContentWrapper>
    </TimeWrapper>
  )
}
export const TimeWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;

  //font-style
  z-index: 1000;
`
export const TimeContentWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: fit-content;
  height: fit-content;
  margin: auto;
  text-align: center;
` //calc(100vw*(22/375) * 3.84);
export const TimeTop = styled.div`
  font-family: "Nanum BaReunHiPi";
  font-style: normal;
  font-weight: 400;
  font-size: calc(100vw * (22 / 375) * 3.84);
  line-height: calc(100vw * (25 / 375) * 3.84);
  text-shadow: 0px 3.84px 15.36px rgba(28, 28, 28, 0.82);

  color: #ffffff;
  // -webkit-text-stroke: 2.5px #FFFFFF;
`
export const TimeBottom = styled.div`
  font-family: "Nanum BaReunHiPi";
  font-style: normal;
  font-weight: 400;
  font-size: calc(100vw * (50 / 375) * 3.84);
  line-height: calc(100vw * (57 / 375) * 3.84);
  text-shadow: 0px 3.84px 15.36px rgba(28, 28, 28, 0.82);

  color: #ffffff;
  // -webkit-text-stroke: 2.5px #FFFFFF;
`

export const FontSpacer = styled.div`
  display: inline-block;
`
